module.exports = __webpack_public_path__ + "img/1.4037fc8b.jpg";